<script>
import { onLogout } from '@/vue-apollo.js'
import {
  mapMutations
} from 'vuex'

export default {
  name: 'Logout',
  mounted () {
    this.Logout()
  },
  methods: {
      ...mapMutations("app", ["setIsLoggedIn"]),
      ...mapMutations('user', ['setUser']),
    Logout() {
      this.setIsLoggedIn(false);
      this.$apollo.mutate({
          mutation: require('@/graphql/mutations/Logout.gql')     
      }).then(data => {    
      }).catch(error => {
      })
      onLogout(this.$apollo.provider.defaultClient)
        .then(() => {
          this.setUser(null)
          localStorage.removeItem('auth-token-expires');
          if(this.$route.query.s == 'expired') {
            this.$router.push({path: 'login', query:  {s: 'expired'}});
            return
          }
          this.$router.push({path: 'login'});
      })  
    }
  },
  template: ''
}
</script>

